import type { FaireProductEntity } from "../../entity_types/product";

export const p_x965pxhqkh: FaireProductEntity = {
  token: "p_x965pxhqkh",
  type: "product",
  name: "Essential Oil Blends - Pure & Uncut Therapeutic Grade",
  brandToken: "b_7jqwqwjp5c",
  brandName: "Aromalee Shop",
  imageUrl: "https://cdn.faire.com/fastly/fee21366a1f18c96f5296f0f54c02a1a097ec8f09dccc8411b6cfa150ba9ec1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1033de193d71a51f69e01b3d36feaa3b986b46cf28553b71b1841ba615e994d7.jpeg"
  ],
  priceDollars: 11.09,
  description: "100% Pure and Uncut Therapeutic Grade Essential Oil Blends Hand Poured In a  10ml Glass Amber Bottle\n\nCONFIDENCE 💛 \n▫️Ylang Ylang, Rosemary, & Jasmine Essential Oils \n\nBenefits: \n▫️Boosts Self Confidence And Clarity \n▫️Calms Mind Body and Soul\n▫️Aids With Inflammation and Fatigue \n\n LOVE 💖 \n▫️Scented With Rose, Sage, & Geranium Essential Oils \n\nBenefits: \n▫️Boosts Emotional and Relationship Healing \n▫️Inspires Compassion and Love\n▫️Aids With Menstrual Cramps and Pain\n\nFOCUS 💙 \n▫️Peppermint & Eucalyptus Essential Oils \n\n\nBenefits: \n▫️Boosts Clarity and Focus \n▫️Calms Mental Stress \n▫️Aids With Headaches and Colds  \n\nSTRESS RELIEF 💜 \n▫️Lavender & Rosemary Essential Oils \n\nBenefits: \n▫️Boosts Relaxation and Insight \n▫️Reduces Anxiety and Stress \n▫️Aids With Insomnia and Nausea \n\nPURIFY 🧡 \n▫️Sweet Orange, Tangerine, & Lemon Essential Oils  \n\nBenefits: \n▫️Boosts Psychic Energy and Cleanses Aura \n▫️Calm and Brightens mood \n▫️Aids With Immunity and Bacteria",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:52.109Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
